import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var StarsSet = styled.div.withConfig({
  displayName: "partials__StarsSet",
  componentId: "sc-120nnp3-0"
})(["display:flex;justify-content:space-between;margin-bottom:12px;", ";"], getFont(-1, 'compact'));
export var FeatureBadge = styled.div.withConfig({
  displayName: "partials__FeatureBadge",
  componentId: "sc-120nnp3-1"
})(["display:flex;align-items:center;flex-shrink:0;"]);
export var FeatureLabel = styled.div.withConfig({
  displayName: "partials__FeatureLabel",
  componentId: "sc-120nnp3-2"
})(["font-size:11px;"]);